<h3>
    <a ui-sref="admin$Register.general({registerId: item.id})" ng-click="itemClick($event)">
        {{ item.name }}
    </a>
</h3>
<div style="padding: 5px 0 0 0">
    {{ item.description }}
</div>